import { FC } from 'react'
import { Button as MuiButton } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { Loader } from 'packages/eid-ui'

const useDefaultStyles = makeStyles((theme) =>
    createStyles({
        root: {
            // minWidth: '177px',
            height: '31px',

            border: `solid 1px ${theme?.palette?.primary?.main}`,
            borderRadius: '16px',

            backgroundColor: '#ffffff',
            color: theme?.palette?.primary?.main,

            boxShadow: '0 0 0 0',
            textTransform: 'capitalize',
        },
    }),
)
const useGreenStyles = makeStyles(
    createStyles({
        root: {
            // minWidth: '177px',
            height: '31px',

            borderRadius: '16px',

            boxShadow: '0 0 0 0',
            textTransform: 'capitalize',

            backgroundColor: 'transparent',
            border: 'solid 1px #01ae8f',

            color: '#01ae8f',
            '&:hover': {
                backgroundColor: '#01ae8f',
                color: 'white',
            },
        },
    }),
)

const useBlueStyles = makeStyles((theme) =>
    createStyles({
        root: {
            // minWidth: '177px',
            height: '31px',
            borderRadius: '16px',
            boxShadow: '0 0 0 0',
            textTransform: 'capitalize',
            backgroundColor: 'transparent',
            border: `solid 1px ${theme?.palette?.primary?.main}`,
            color: theme?.palette?.primary?.main,
            '&:hover': {
                backgroundColor: theme?.palette?.primary?.main,
                color: 'white',
            },
        },
    }),
)

export interface ButtonProps {
    onClick: any
    isLoading?: boolean
    disabled?: boolean
    variant?: string
    endIcon?: any
}

export const Button: FC<ButtonProps> = (props) => {
    const blueClasses = useBlueStyles()
    const greenClasses = useGreenStyles()
    const defaultClasses = useDefaultStyles()

    function getStylingClasses(variant?: string) {
        switch (variant) {
            case 'blue':
                return blueClasses
            case 'green':
                return greenClasses
            default:
                return defaultClasses
        }
    }
    let classes = getStylingClasses(props.variant)

    return (
        <MuiButton
            size="small"
            classes={classes}
            variant="outlined"
            onClick={props.onClick}
            disabled={props.disabled}
            endIcon={props.endIcon}
        >
            {props.isLoading ? <Loader size={0.6} /> : props.children}
        </MuiButton>
    )
}
